import { useTranslation } from "next-i18next";
import Link from "next/link";
import Image from "next/image";
import AboutUsImage from "@/images/about-us-photo.png";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div
      id="about-us"
      className="flex flex-col-reverse lg:flex-row items-center justify-between gap-[40px] bg-white max-w-[90%] md:py-[200px] py-[100px] mx-auto"
    >
      <div className="relative flex flex-col items-center justify-center gap-[20px]">
        <div className="w-full flex items-center justify-center">
          <Image
            src={AboutUsImage}
            alt="About Us"
            width={540}
            height={566}
            loading="lazy"
          />
        </div>
      </div>

      <div className="flex-1 flex flex-col gap-[24px] sm:gap-[32px] w-full lg:max-w-[45%]">
        <h2 className="text-[32px] md:text-[48px] lg:text-[54px] xl:text-[60px] 2xl:text-[80px] font-[500] leading-[120%] text-transparent bg-clip-text bg-gradient-to-b from-[#091F59] to-[#1A3884]">
          {t("home-page.about-us-section-title")}
        </h2>

        <p 
          className="text-[16px] lg:text-[18px] xl:text-[20px] font-[400] leading-[160%] text-gray-700"
          dangerouslySetInnerHTML={{ __html: t("home-page.about-us-section-description") }}
        />

        <div className="flex flex-col sm:flex-row gap-[16px] sm:gap-[20px]">
          <Link href="/apply" className="w-full lg:w-[200px] xl:w-[220px]">
            <button className="flex h-[56px] w-full items-center justify-center rounded-full border border-main-pink bg-main-pink px-[12px] text-[16px] font-[500] text-white transition duration-300 hover:text-main-pink hover:bg-white">
              {t("apply-btn")}
            </button>
          </Link>

          <Link href="/qwasar" className="w-full lg:w-[200px] xl:w-[220px]">
            <button className="flex h-[56px] w-full items-center justify-center rounded-full border border-gray-400 bg-white px-[12px] text-[16px] font-[500] text-gray-700 transition duration-300 hover:text-white hover:bg-[#091F59] hover:border-transparent">
              QWASAR Silicon Valley
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
